import * as Yup from 'yup'

export const siteAgreementSchema = Yup.object({
  expiresAt: Yup.date(),
  siteMetadata: Yup.object({
    exclusivityExpiry: Yup.date(),
  }),
})
